import styled from 'styled-components'
import { backgroundOrange, blue, blackOrange, darkOrange, warmTint, white } from '@/theme/colors'
import { media, motion, radii } from '@/theme/tokens'
import { fontSizes, leading, text } from '@/theme/typography'

export const Page = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	overflow-y: auto;
	${text.body}
	color: ${blackOrange};
	-webkit-font-smoothing: antialiased;
	background:
		radial-gradient(900px 420px at 50% -160px, ${warmTint} 0%, ${warmTint}00 70%),
		${backgroundOrange};
`

export const TopBar = styled.header`
	flex: none;
	display: flex;
	align-items: center;
	justify-content: space-between;
	max-width: 980px;
	width: 100%;
	margin: 0 auto;
	padding: 26px 28px;

	${media.tablet} {
		padding: 20px;
	}
`

export const Brand = styled.a`
	display: flex;
	align-items: center;
	gap: 11px;
	text-decoration: none;

	img {
		width: 32px;
		height: 32px;
	}

	b {
		${text.heading}
		font-weight: 900;
		color: ${blackOrange};
	}
`

export const HelpLink = styled.a`
	font-size: ${fontSizes.small};
	font-weight: 500;
	color: ${darkOrange};
	text-decoration: none;
	transition: color ${motion.fast};

	b {
		color: ${blackOrange};
		font-weight: 700;
	}

	&:hover {
		color: ${blackOrange};
	}

	@media (prefers-reduced-motion: reduce) {
		transition: none;
	}
`

export const Main = styled.main`
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 12px 28px 56px;
`

/* Geometry matches the marketing site's join-trip card (JoinTripCard.astro):
   same width, column split, paddings, and stature. */
export const Card = styled.div`
	display: grid;
	grid-template-columns: 0.92fr 1.08fr;
	width: 100%;
	max-width: 920px;
	/* The landing card's natural height; keeps the two cards the same size. */
	min-height: 516px;
	background: ${white};
	border-radius: ${radii.band};
	overflow: hidden;
	box-shadow: 0 18px 50px ${blackOrange}1a;

	${media.tablet} {
		grid-template-columns: 1fr;
		max-width: 460px;
		min-height: 0;
	}
`

export const Hero = styled.section`
	background: ${blue};
	color: ${white};
	padding: 44px 40px;
	display: flex;
	flex-direction: column;
	overflow: hidden;

	${media.tablet} {
		padding: 36px 30px;
	}
`

export const HeroTitle = styled.h1`
	${text.hero}
	color: ${white};
	margin: 0;
	text-wrap: balance;

	${media.tablet} {
		font-size: ${fontSizes.heroSm};
	}
`

export const Tagline = styled.p`
	margin: 18px 0 0;
	font-size: ${fontSizes.body};
	line-height: ${leading.body};
	color: ${white}cc;
	max-width: 300px;
	text-wrap: pretty;
`

export const Mark = styled.div`
	margin-top: auto;
	padding-top: 48px;
	display: flex;
	align-items: center;
	gap: 9px;
	opacity: 0.85;

	img {
		width: 22px;
		height: 22px;
	}

	b {
		${text.label}
		color: ${white};
	}
`
